import { useEffect, useState } from "react";

export type PartnerWorkspaceTab = "script" | "upload" | "activity";

export function usePartnerWorkspaceTab(
  scriptId: string,
  pendingUploadTab: boolean,
  showPreflightSubmit: boolean,
  onPendingUploadTabConsumed: () => void,
): readonly [PartnerWorkspaceTab, (tab: PartnerWorkspaceTab) => void] {
  const [activeTab, setActiveTab] = useState<PartnerWorkspaceTab>("script");

  useEffect(() => {
    setActiveTab("script");
  }, [scriptId]);

  useEffect(() => {
    if (!pendingUploadTab || !showPreflightSubmit) return;
    setActiveTab("upload");
    onPendingUploadTabConsumed();
  }, [pendingUploadTab, showPreflightSubmit, onPendingUploadTabConsumed, scriptId]);

  useEffect(() => {
    if (activeTab === "upload" && !showPreflightSubmit) {
      setActiveTab("script");
    }
  }, [activeTab, showPreflightSubmit]);

  return [activeTab, setActiveTab];
}
